// extracted by mini-css-extract-plugin
export default {"iconSuccess":"UdEKz","success-icon":"VwOQt","savePersonalDataBtn":"DLFGB"};